module.exports = __webpack_public_path__ + "img/banner-6.40da7ae5.jpg";